module.exports = __webpack_public_path__ + "img/may_prize_title.157df335.png";